import React, { useState } from 'react';
import { Table, Card, Input, Button, Space, Tag } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import styles from './System.module.scss';

const { Search } = Input;

const PackageList = ({ packageList }) => {
  const [, setSearchText] = useState('');
  const [filteredPackages, setFilteredPackages] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);

  // 패키지 목록 파싱
  const parsePackageList = (data) => {
    if (!data || data === 'N/A') return [];
    
    try {
      const packages = [];
      const lines = data.trim().split('\n');
      
      lines.forEach(line => {
        // rpm 출력 형식에 맞게 파싱
        const parts = line.split('-');
        if (parts.length >= 3) {
          const name = parts[0];
          const version = parts.slice(1, -1).join('-');
          const release = parts[parts.length - 1];
          
          packages.push({
            name,
            version,
            release,
            fullName: line,
            key: line
          });
        }
      });
      
      return packages;
    } catch (error) {
      console.error('Error parsing package list:', error);
      return [];
    }
  };

  const packages = parsePackageList(packageList);

  const handleSearch = (value) => {
    setSearchText(value);
    if (value) {
      const filtered = packages.filter(pkg => 
        pkg.name.toLowerCase().includes(value.toLowerCase()) ||
        pkg.fullName.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredPackages(filtered);
      setIsFiltered(true);
    } else {
      setFilteredPackages([]);
      setIsFiltered(false);
    }
  };

  const exportCSV = () => {
    const dataToExport = isFiltered ? filteredPackages : packages;
    const csvContent = [
      ['Package Name', 'Version', 'Release', 'Full Name'].join(','),
      ...dataToExport.map(pkg => [
        pkg.name,
        pkg.version,
        pkg.release,
        pkg.fullName
      ].join(','))
    ].join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'package_list.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Card 
      title="설치된 패키지 목록" 
      className={styles.systemCard}
      extra={
        <Space>
          <Search
            placeholder="패키지 검색..."
            allowClear
            onSearch={handleSearch}
            style={{ width: 250 }}
          />
          <Button 
            icon={<DownloadOutlined />} 
            onClick={exportCSV}
            title="CSV로 내보내기"
          >
            CSV 내보내기
          </Button>
        </Space>
      }
    >
      {isFiltered && (
        <div className={styles.filterInfo}>
          <Tag color="blue">{filteredPackages.length} 패키지 찾음</Tag>
          <Button 
            type="link" 
            onClick={() => {
              setSearchText('');
              setFilteredPackages([]);
              setIsFiltered(false);
            }}
          >
            필터 초기화
          </Button>
        </div>
      )}
      
      <Table 
        dataSource={isFiltered ? filteredPackages : packages}
        rowKey="key"
        pagination={{ pageSize: 10 }}
        columns={[
          { title: '패키지 이름', dataIndex: 'name', key: 'name' },
          { title: '버전', dataIndex: 'version', key: 'version' },
          { title: '릴리스', dataIndex: 'release', key: 'release' },
          { title: '전체 이름', dataIndex: 'fullName', key: 'fullName' }
        ]}
      />
    </Card>
  );
};

export default PackageList;